import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { get } from 'lodash'
import { notification } from 'redux/modules/app'
import { actions as actionsApi } from 'redux/modules/api'

function decorator(config = { loadOnMount: true }) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, app, auth }) => ({
          localeId: app.locale.id,
          actions: api.actions,
          activeOrganization: auth.organization,
          user: auth.user
        }),
        { ...actionsApi, notification }
      )
    )

    class Actions extends Component {
      static propTypes = {
        activeOrganization: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        getParticipantActions: PropTypes.func.isRequired,
        getOrganizationActions: PropTypes.func.isRequired,
        getAwardLeaderActions: PropTypes.func.isRequired,
        getAssessorActions: PropTypes.func.isRequired,
        getAwardActions: PropTypes.func.isRequired,
        removeActions: PropTypes.func.isRequired,
        decoFilter: PropTypes.string,
        decoActions: PropTypes.string,
        decoAwardId: PropTypes.number,
        params: PropTypes.object
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        config.loadOnMount && this.handleGetListToFetch(this.props.actions)
      }

      componentWillReceiveProps (nextProps) {
        const { actions, decoAwardId } = this.props
        const { filter, limit, offset, sort } = nextProps.actions

        if (
          actions.filter !== filter ||
          actions.limit !== limit ||
          actions.offset !== offset ||
          actions.sort !== sort ||
          decoAwardId !== nextProps.decoAwardId
        ) {
          this.handleGetListToFetch(nextProps.actions, {
            actions: nextProps.actions,
            params: nextProps.params,
            decoActions: nextProps.decoActions,
            decoAwardId: nextProps.decoAwardId
          })
        }
      }

      componentWillUnmount () {
        this.props.removeActions()
      }

      key = uuid.v1()

      decoFilter = () => {
        const { decoFilter } = this.props

        switch (decoFilter || config.filter) {
          default:
            return ''
        }
      }

      handleGetListToFetch = actions => {
        const { params, decoActions, decoAwardId } = this.props

        switch (decoActions) {
          case 'participant':
            this.handleGetParticipantActions(actions, params.id)
            break
          case 'award':
            this.handleGetAwardActions(actions, decoAwardId || params.id)
            break
          case 'myOrganization':
            this.handleGetOrganizationActions(
              actions,
              this.props.activeOrganization.id
            )
            break
          case 'awardLeader':
            this.handleGetAwardLeaderActions(
              actions,
              this.props.activeOrganization.id,
              params && params.id
            )
            break
          case 'assessor':
            this.handleGetAssessorActions(
                actions,
                get(this.props, 'params.organizationId') || this.props.activeOrganization.id,
                params && params.assessorId
            )
            break
          case 'organizations':
            this.handleGetOrganizationActions(actions, params.id)
            break
          default:
        }
      }

      handleGetCustomParticipantActions = (actions, filter, id) =>
          this.props.getParticipantActions(actions, filter, id)

      handleGetParticipantActions = (actions, id) =>
        this.props.getParticipantActions(actions, this.decoFilter(), id)

      handleGetOrganizationActions = (actions, id) => {
        this.props.getOrganizationActions(actions, this.decoFilter(), id)
      }

      handleGetAwardLeaderActions = (actions, organizationId, awardLeaderPersonId) => {
        this.props.getAwardLeaderActions(actions, this.decoFilter(), organizationId, awardLeaderPersonId)
      }

      handleGetAssessorActions = (actions, organizationId, assessorPersonId) => {
        this.props.getAssessorActions(actions, this.decoFilter(), organizationId, assessorPersonId)
      }

      handleGetAwardActions = (actions, id) =>
        this.props.getAwardActions(actions, this.decoFilter(), id)

      render() {
        return (
          <ComposedComponent
            key={this.key}
            onGetActions={this.handleGetListToFetch}
            getParticipantActions={this.handleGetCustomParticipantActions}
            {...this.props}
          />
        )
      }
    }

    return enhance(Actions)
  }
}

export default decorator
